var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-body"},[_c('FullCalendar',{attrs:{"options":_vm.calendarOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }